"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPairingCodeResponseReady = exports.MatterStatus = void 0;
var MatterStatus;
(function (MatterStatus) {
    MatterStatus["READY"] = "READY";
    MatterStatus["NOT_READY"] = "NOT_READY";
    MatterStatus["NO_BRIDGE"] = "NO_BRIDGE";
})(MatterStatus = exports.MatterStatus || (exports.MatterStatus = {}));
const isPairingCodeResponseReady = (resp) => resp.status === MatterStatus.READY;
exports.isPairingCodeResponseReady = isPairingCodeResponseReady;
//# sourceMappingURL=Matter.js.map